export default __webpack_public_path__ + "static/media/aboud.cee5e51f.png";